import {
  AgentConfigSummarySchema,
  AgentGlossaryTermSchema,
  AgentGlossaryTermsResponseSchema,
  AgentMemoryEntriesResponseSchema,
  AgentMemoryEntrySchema,
  AgentPromptVersionSchema,
  AgentPromptVersionsResponseSchema,
  type AgentConfigSummary,
  type AgentGlossaryTerm,
  type AgentGlossaryTermsResponse,
  type AgentMemoryEntriesResponse,
  type AgentMemoryEntry,
  type AgentPromptVersion,
  type AgentPromptVersionsResponse,
  type CreateAgentMemoryEntryInput,
  type CreateAgentGlossaryTermInput,
  type CreateAgentPromptDraftInput,
  type PatchAgentMemoryEntryInput,
  type PatchAgentGlossaryTermInput,
} from '@magimp/shared';
import { request } from '../client.js';

const BASE = '/dashboards/agent/v2/admin';

export function getAgentConfigSummary(): Promise<AgentConfigSummary> {
  return request(`${BASE}/config`, { method: 'GET' }, {}, AgentConfigSummarySchema);
}

export function listAgentPromptVersions(): Promise<AgentPromptVersionsResponse> {
  return request(`${BASE}/prompts`, { method: 'GET' }, {}, AgentPromptVersionsResponseSchema);
}

export function createAgentPromptDraft(
  body: CreateAgentPromptDraftInput,
): Promise<AgentPromptVersion> {
  return request(
    `${BASE}/prompts`,
    { method: 'POST', body: JSON.stringify(body), headers: { 'content-type': 'application/json' } },
    {},
    AgentPromptVersionSchema,
  );
}

export function activateAgentPromptVersion(id: string): Promise<AgentPromptVersion> {
  return request(
    `${BASE}/prompts/${id}/activate`,
    { method: 'POST' },
    {},
    AgentPromptVersionSchema,
  );
}

export function listAgentGlossaryTerms(): Promise<AgentGlossaryTermsResponse> {
  return request(`${BASE}/glossary`, { method: 'GET' }, {}, AgentGlossaryTermsResponseSchema);
}

export function createAgentGlossaryTerm(
  body: CreateAgentGlossaryTermInput,
): Promise<AgentGlossaryTerm> {
  return request(
    `${BASE}/glossary`,
    { method: 'POST', body: JSON.stringify(body), headers: { 'content-type': 'application/json' } },
    {},
    AgentGlossaryTermSchema,
  );
}

export function patchAgentGlossaryTerm(
  id: string,
  body: PatchAgentGlossaryTermInput,
): Promise<AgentGlossaryTerm> {
  return request(
    `${BASE}/glossary/${id}`,
    {
      method: 'PATCH',
      body: JSON.stringify(body),
      headers: { 'content-type': 'application/json' },
    },
    {},
    AgentGlossaryTermSchema,
  );
}

export function approveAgentGlossaryTerm(id: string): Promise<AgentGlossaryTerm> {
  return request(`${BASE}/glossary/${id}/approve`, { method: 'POST' }, {}, AgentGlossaryTermSchema);
}

export function rejectAgentGlossaryTerm(id: string): Promise<AgentGlossaryTerm> {
  return request(`${BASE}/glossary/${id}/reject`, { method: 'POST' }, {}, AgentGlossaryTermSchema);
}

export function archiveAgentGlossaryTerm(id: string): Promise<AgentGlossaryTerm> {
  return request(`${BASE}/glossary/${id}/archive`, { method: 'POST' }, {}, AgentGlossaryTermSchema);
}

export function listAgentMemoryEntries(): Promise<AgentMemoryEntriesResponse> {
  return request(`${BASE}/memory`, { method: 'GET' }, {}, AgentMemoryEntriesResponseSchema);
}

export function createAgentMemoryEntry(
  body: CreateAgentMemoryEntryInput,
): Promise<AgentMemoryEntry> {
  return request(
    `${BASE}/memory`,
    { method: 'POST', body: JSON.stringify(body), headers: { 'content-type': 'application/json' } },
    {},
    AgentMemoryEntrySchema,
  );
}

export function patchAgentMemoryEntry(
  id: string,
  body: PatchAgentMemoryEntryInput,
): Promise<AgentMemoryEntry> {
  return request(
    `${BASE}/memory/${id}`,
    {
      method: 'PATCH',
      body: JSON.stringify(body),
      headers: { 'content-type': 'application/json' },
    },
    {},
    AgentMemoryEntrySchema,
  );
}

export function approveAgentMemoryEntry(id: string): Promise<AgentMemoryEntry> {
  return request(`${BASE}/memory/${id}/approve`, { method: 'POST' }, {}, AgentMemoryEntrySchema);
}

export function rejectAgentMemoryEntry(id: string): Promise<AgentMemoryEntry> {
  return request(`${BASE}/memory/${id}/reject`, { method: 'POST' }, {}, AgentMemoryEntrySchema);
}

export function archiveAgentMemoryEntry(id: string): Promise<AgentMemoryEntry> {
  return request(`${BASE}/memory/${id}/archive`, { method: 'POST' }, {}, AgentMemoryEntrySchema);
}
